import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { API_BASE_URL } from '../../constatns';
import ReactGA from 'react-ga';
import { isMobile } from 'react-device-detect';
import Alert from 'react-s-alert';

class KickstarterBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      email: '',
      name: '',
      title: 'Kickstarter',
      contents: '',
      mailSent: false,
      error: null,
    };
    this.openModal = this.openModal.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.setState({ isOpen: false });
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  handleFormSubmit = (e) => {
    e.preventDefault();

    fetch(API_BASE_URL + '/bbs/inquiry/', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(this.state),
    })
      .then((e) => e.json())
      .then((e) => {
        this.setState({
          email: '',
          isOpen: false,
        });

        ReactGA.event({
          category: 'KICKSTARTER',
          action: 'Registered',
        });

        if (isMobile) {
          alert("You're successfully registered!");
        } else {
          Alert.success("You're successfully registered!");
        }
      })
      .catch((error) => this.setState({ error: error.message }));
  };

  render() {
    return (
      <section className="banner-area relative">
        <div className="container-fluid">
          <div className="row fullscreen align-items-center justify-content-center">
            <div className="banner-content">
              <h1>See you at Kickstarter</h1>
              <h2>in September</h2>
              <button className="preorder-btn" onClick={this.openModal}>
                PREORDER
              </button>
              <h3>Halasz Helps Saving the Environment!</h3>
              <div className={'justify-content-center'}>
                Halasz Fishing Grip is a IoT fishing grip that can measure the <b>WEIGHT</b> and the <b>LENGTH</b> of the caught fish{' '}
                <b>AT THE SAME TIME.</b>
                <br /> It can be used in conjunction with a user-oriented data based, HALASZ FISHING ONLY AI APP.
              </div>
            </div>
          </div>
        </div>

        <Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" open={this.state.isOpen} className={'preorder'}>
          <DialogTitle id="simple-dialog-title" className={'title'}>
            PRE ORDER NOW
          </DialogTitle>
          <div className="subscribe">
            <div className="subscribe-form relative mb-10">
              <form target="_blank" method="get" className="newsletter relative">
                <input
                  name="EMAIL"
                  placeholder="Your email address"
                  className="common-input"
                  required=""
                  type="email"
                  value={this.state.email}
                  onChange={(e) => {
                    this.setState({
                      email: e.target.value,
                    });
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: '100%' }}
                  disableElevation
                  onClick={(e) => this.handleFormSubmit(e)}
                >
                  Submit
                </Button>
                <div className="info" />
              </form>
            </div>
          </div>
        </Dialog>
      </section>
    );
  }
}

export default KickstarterBanner;
